import React from 'react';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import '../styles/Pagination.css';

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  const getPages = () => {
    const pages = [];
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + 4);

    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className="pagination-wrapper">
      <button disabled={currentPage === 1} onClick={() => onPageChange(1)}><FaAngleDoubleLeft /></button>
      <button disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)}><FaAngleLeft /></button>

      {getPages().map((page) => (
        <button
          key={page}
          className={page === currentPage ? 'active' : ''}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      ))}

      <button disabled={currentPage === totalPages} onClick={() => onPageChange(currentPage + 1)}><FaAngleRight /></button>
      <button disabled={currentPage === totalPages} onClick={() => onPageChange(totalPages)}><FaAngleDoubleRight /></button>
    </div>
  );
};

export default Pagination;
